window.openLocation = function(href){
	$.blockUI({message: '<h4>'+$.i18n._(7801)+'</h4>'});
	
    $('.header-locations').slideToggle();
    setTimeout(function(){
        moveWindowToElement('body',0,80);    
    },80);
	
	location.href = href;
}